import { loadLocale } from './libs/DayJsHelper'
import './ygdrasil/libs/DayJsHelper'

loadLocale()
